"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.time = exports.datetime = exports.date = exports.minimumLength = void 0;
const lang_1 = __importDefault(require("../../../lang"));
exports.minimumLength = 8;
function date() {
    return this.matches(/^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/, (0, lang_1.default)().validation.invalidDate());
}
exports.date = date;
function datetime() {
    return this.matches(/^[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1]) (2[0-3]|[01][0-9]):[0-5][0-9]:[0-5][0-9](\.?\d*)$/, (0, lang_1.default)().validation.invalidDatetime());
}
exports.datetime = datetime;
function time() {
    return this.matches(/^(2[0-3]|[01][0-9]):[0-5][0-9]:[0-5][0-9](\.?\d*)$/, (0, lang_1.default)().validation.invalidTime());
}
exports.time = time;
